export default __webpack_public_path__ + "static/media/img-happens-at-butchery-selected.7a8f6845.svg";